<template>
  <a-breadcrumb :routes="breadcrumbList" class="breadcrumb">
    <template slot="itemRender" slot-scope="{ route, params, routes }">
      <template v-if="!route.meta.hideInBread">
        <span v-if="routes.indexOf(route) === routes.length - 1">
          {{ route.meta.title }}
        </span>
        <router-link v-else :to="route.path">
          {{ route.meta.title }}
        </router-link>
      </template>
    </template>
  </a-breadcrumb>
</template>

<script>
export default {
  computed: {
    breadcrumbList() {

      if (!this.$route.matched || this.$route.matched.length <= 1) {
        return this.$route.matched; // 如果没有匹配项或只有一个匹配项，直接返回
      }

      const seenPaths = new Set(); // 用于跟踪已经遇到的路径
      const filteredMatched = []; // 存储过滤后的匹配项

      this.$route.matched.forEach((item) => {
        if (!seenPaths.has(item.path)) {
          // 如果路径尚未被记录
          seenPaths.add(item.path); // 将路径添加到已记录集合中
          filteredMatched.push(item); // 将项添加到过滤后的数组中
        }
      });

      return filteredMatched;
    },
  },
};
</script>

<style lang="less" scoped>
.breadcrumb {
  font-size: 0.9rem;
}
</style>
